import { useEffect, useState } from "preact/hooks"
import SendAchievement, { useTimer } from "../components/SendAchievement"
import { Now } from "../rooms/keynotes"
import { getDayRow, leaderboardOptIn, mapAgendas } from "../utils"
import { achievements } from "./achievements"
import { userID } from "src/utils/datalayer"

const dayOne = `08:45 - 10:00	Keynote: Harnessing the Power of Positivity
10:15 - 11:00	V1.1 Diffused Perspectives Virus (DPV): How to fight this highly contagious virus that ruins your awareness programme
10:15 - 11:00	V1.1 Diffused Perspectives Virus (DPV): How to fight this highly contagious virus that ruins your awareness programme
11:30 - 12:15	V2.1 Danger From Within: Real-life insider threats and how to address this topic
13:30 - 14:15 	V3.1 Manipulator to Listener: An emotional intelligence (EQ) journey
14:30 - 15:15	V4.1 Security Leadership Panel: Staying the course
15:45 - 16:30 	V5.1 Risky Business: Building a flexible everyday risk framework
16:45 - 17:45	Keynote: Robot Ethics and the Future of Human-Robot Interaction`

const dayTwo = `09:00 - 10:00	Keynote: Embedding a Culture of Innovation into Everyone’s DNA
10:15 - 11:00	V6.1 Why are our Teams Burning Out? Lessons learnt to keep the fires at bay
11:30 - 12:15	V7.1 A Gen Z'ers Perspective on Rejuvenating Your Security Workforce
13:30 - 14:15 	V8.1 Regulation vs. Innovation: How much is too much?
14:30 - 15:15	V9.1 Are You Compliant or are You Ready? Surviving an extinction level event
15:45 - 16:45 	Keynote: How to Think Like a Hacker and Help Your Organisation Handle Incidents
16:45 - 17:45	Panel Discussion: Hacking ICS and handling OT incidents`

const dayThree = `09:00 - 10:00	Keynote: The State of Security: Using pressure to prosper as a security leader
10:15 - 11:00	V10.1 Securing the Supply Chain: A cross-collaborative approach
11:30 - 12:30	Keynote: The Power of Choice`

export default function auditoriumOne() {
    const now = new Date()

    const dates = [
        { day: new Date("2025-06-02 00:00:00.000-05:00"), sessions: mapAgendas("2025-06-02", dayOne) },
        { day: new Date("2025-06-03 08:00:00.000-05:00"), sessions: mapAgendas("2025-06-03", dayTwo) },
        { day: new Date("2025-06-04 08:00:00.000-05:00"), sessions: mapAgendas("2025-06-04", dayThree) }
    ]

    return getDayRow(dates, it => it.day, now)?.sessions?.map(([start, end, title]) => {
        return 	{
            start,
            end,
            title,
            room: "Auditorium",
            path: "/auditorium",
        }
    })
}

export const getCurrentSession = (sessions = []) => {
    if (sessions.length === 0) return null

    const now = Now()

    const parsed = sessions.map(it => ({
        ...it,
        start: new Date(it.start),
        end: new Date(it.end)
    }))

    return parsed.find(it => it.start.getTime() <= now.getTime() && it.end.getTime() > now.getTime())
}

export const SessionsComponent = ({sessions = [], name = "Auditorium"}) => {

    const timer = useTimer()

    const [ss, setSessions] = useState(sessions.map(it => ({
        ...it,
        start: new Date(it.start),
        end: new Date(it.end)
    })))

    const [current, setCurrent] = useState(null)

    useEffect(() => {
        const sess = getCurrentSession(ss)
        if (sess !== current && sess) {
            const id = achievements.find(it => {
                if (it.name.startsWith("Keynote"))
                    return it.name === `Watch ${sess.title}`
                return it.name === `Watch Breakout Session - ${sess.title}`
            })?.id
            setCurrent({id, ...sess})
        }
    }, [timer])

    useEffect(() => {
        setSessions(sessions.map(it => ({
            ...it,
            start: new Date(it.start),
            end: new Date(it.end)
        })))
    }, [sessions])

    if (!leaderboardOptIn) return <></>

    return current && current.id ? <SendAchievement
        key={name}
        achievementId={current.id} 
        eventId="161759" 
        userId={userID}
        minimalTime={15}
    /> : <></>
}